// Thin-stroke outline icons matching design/Business Hub.html.
// Each icon renders an 18px currentColor SVG so the nav can tint it.

const Svg = ({ children, strokeWidth = 1.8, size = 18, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {children}
  </svg>
);

const BusinessHubIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="3" width="7" height="7" rx="1.4" />
    <rect x="14" y="3" width="7" height="7" rx="1.4" />
    <rect x="3" y="14" width="7" height="7" rx="1.4" />
    <rect x="14" y="14" width="7" height="7" rx="1.4" />
  </Svg>
);

const TimeCapsulesIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Svg>
);

const MomentMakerIcon = (props) => (
  <Svg {...props}>
    <path d="M12 3v5M12 16v5M3 12h5M16 12h5M6 6l3 3M15 15l3 3M18 6l-3 3M9 15l-3 3" />
  </Svg>
);

const RafflesIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="6" width="18" height="12" rx="2" />
    <path d="M12 6v12" strokeDasharray="2 2" />
  </Svg>
);

const CouponsIcon = (props) => (
  <Svg {...props}>
    <path d="M3 12l9-9 9 9-9 9z" />
  </Svg>
);

const ContentIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="9" cy="9" r="2" />
    <path d="M21 15l-5-5L5 21" />
  </Svg>
);

const PlaylistsIcon = (props) => (
  <Svg {...props}>
    <path d="M4 7h12M4 12h12M4 17h8M19 9v8l3-1.5z" />
  </Svg>
);

const InssaLiveIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="4" width="18" height="13" rx="2" />
    <path d="M8 21h8M12 17v4" />
  </Svg>
);

const AnalyticsIcon = (props) => (
  <Svg {...props}>
    <path d="M4 19V5M4 19h16M8 15l3-4 3 2 4-6" />
  </Svg>
);

const ChallengesIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="8" r="5" />
    <path d="M8.5 12.5L7 21l5-3 5 3-1.5-8.5" />
  </Svg>
);

// Challenges medal with Moment Maker's spark, so the pair reads as a family.
const ChallengeMakerIcon = (props) => (
  <Svg {...props}>
    <circle cx="10" cy="8" r="4.5" />
    <path d="M6.7 12L5.5 20l4.5-2.7 3 1.8" />
    <path d="M18 3v3M18 10v3M15 8h-1.5M22 8h-1.5" />
  </Svg>
);

const CampaignsIcon = (props) => (
  <Svg {...props}>
    <path d="M3 11l15-5v12L3 14z" />
    <path d="M3 11v3M8 12.5V18l3 1v-5" />
  </Svg>
);

const TitlesIcon = (props) => (
  <Svg {...props}>
    <path d="M3 8l9-5 9 5-9 5zM3 8v8l9 5M21 8v8l-9 5" />
  </Svg>
);

const TvRailsIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="4" width="18" height="14" rx="2" />
    <path d="M3 9h18M3 13.5h18" />
  </Svg>
);

const SettingsIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 13a7.5 7.5 0 000-2l2-1.4-2-3.4-2.3 1a7.6 7.6 0 00-1.7-1l-.4-2.6h-4l-.4 2.6a7.6 7.6 0 00-1.7 1l-2.3-1-2 3.4 2 1.4a7.5 7.5 0 000 2l-2 1.4 2 3.4 2.3-1a7.6 7.6 0 001.7 1l.4 2.6h4l.4-2.6a7.6 7.6 0 001.7-1l2.3 1 2-3.4z" />
  </Svg>
);

const UsersIcon = (props) => (
  <Svg {...props}>
    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
  </Svg>
);

const PointsIcon = (props) => (
  <Svg {...props}>
    <path d="M12 2l2.9 6 6.6.5-5 4.3 1.6 6.5L12 16l-6.1 3.3L7.5 12.8l-5-4.3L9.1 8z" />
  </Svg>
);

const PromoCodesIcon = (props) => (
  <Svg {...props}>
    <path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0l-7.4-7.4A2 2 0 013 12V5a2 2 0 012-2h7a2 2 0 011.4.6l7.2 7.2a2 2 0 010 2.8z" />
    <circle cx="8" cy="8" r="1.4" />
  </Svg>
);

const PinTemplatesIcon = (props) => (
  <Svg {...props}>
    <path d="M12 21s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z" />
    <circle cx="12" cy="9" r="2.5" />
  </Svg>
);

const GlobeIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a14 14 0 000 18M12 3a14 14 0 010 18" />
  </Svg>
);

export const NAV_ICON_COMPONENTS = {
  analytics: AnalyticsIcon,
  businessHub: BusinessHubIcon,
  campaigns: CampaignsIcon,
  challenges: ChallengesIcon,
  challengeMaker: ChallengeMakerIcon,
  content: ContentIcon,
  coupons: CouponsIcon,
  inssaLive: InssaLiveIcon,
  momentMaker: MomentMakerIcon,
  pinTemplates: PinTemplatesIcon,
  platformSettings: SettingsIcon,
  playlists: PlaylistsIcon,
  points: PointsIcon,
  promoCodes: PromoCodesIcon,
  raffles: RafflesIcon,
  titles: TitlesIcon,
  timeCapsules: TimeCapsulesIcon,
  timeCapsuleSeeder: GlobeIcon,
  tvRails: TvRailsIcon,
  users: UsersIcon,
};

export function renderNavIcon(iconComponent, props) {
  const Icon = iconComponent;
  return Icon ? <Icon {...props} /> : null;
}
